import {
    NoteAndCommentary,
    NoteCategory,
    NoteDetails,
    NoteDto,
} from '../coaching-base/general';
import {
    CmpsFormField,
    CmpsFormFields,
} from '../coaching-observation/experimental.form';

import { NoteDetailFormValue } from './note-detail-form-value.model';

export interface NoteDetailFormFields extends CmpsFormFields {
    TRACKING_ID: CmpsFormField;
    TRACKING_TIME: CmpsFormField;
    TRACKING_ORIGINAL: CmpsFormField;
    NOTE_ID: CmpsFormField;
    CONTENTS: CmpsFormField;
    CATEGORY: CmpsFormField;
    CHANGED: CmpsFormField;
    DIFF_ITEM_ID: CmpsFormField;
    CREATED_BY_FIRST_NAME: CmpsFormField;
    CREATED_BY_LAST_NAME: CmpsFormField;
    UPDATED_BY: CmpsFormField;
    UPDATED_BY_FIRST_NAME: CmpsFormField;
    UPDATED_BY_LAST_NAME: CmpsFormField;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NoteDetailFormFields: NoteDetailFormFields = {
    TRACKING_ID: {
        name: 'trackingId',
        label: undefined,
    },
    TRACKING_TIME: {
        name: 'trackingTime',
        label: undefined,
    },
    TRACKING_ORIGINAL: {
        name: 'trackingOriginal',
        label: undefined,
    },
    NOTE_ID: {
        name: 'noteId',
        label: '',
    },
    CONTENTS: {
        name: 'contents',
        label: '',
    },
    CATEGORY: {
        name: 'category',
        label: '',
    },
    CHANGED: {
        name: 'changed',
        label: '',
    },
    DIFF_ITEM_ID: {
        name: 'diffItemId',
        label: '',
    },
    CREATED_BY_FIRST_NAME: {
        name: 'createdByFirstName',
        label: '',
    },
    CREATED_BY_LAST_NAME: {
        name: 'createdByLastName',
        label: '',
    },
    UPDATED_BY: {
        name: 'updatedBy',
        label: '',
    },
    UPDATED_BY_FIRST_NAME: {
        name: 'updatedByFirstName',
        label: '',
    },
    UPDATED_BY_LAST_NAME: {
        name: 'updatedByLastName',
        label: '',
    },
};

export function createNoteDetail(category?: NoteCategory): NoteDetailFormValue {
    return {
        trackingId: Math.random(),
        trackingTime: Date.now(),
        trackingOriginal: null,
        noteId: null,
        contents: null,
        category,
        changed: false,
        diffItemId: null,
        inEditMode: true,
    };
}

// TODO move?
export function noteDetailFormValueTransformer(
    model: NoteDto,
): NoteDetailFormValue {
    if (!model) {
        return null;
    }
    return {
        trackingId: Math.random(),
        trackingTime: Date.now(),
        trackingOriginal: model,
        noteId: model.noteId,
        contents: model.contents,
        category: model.noteCategoryId,
        changed: null,
        diffItemId: model.diffItemId,
        createdByFirstName: model.createdByFirstName,
        createdByLastName: model.createdByLastName,
        updatedBy: model.updatedBy,
        updatedByFirstName: model.updatedByFirstName,
        updatedByLastName: model.updatedByLastName,
    };
}

// TODO move?
export function noteDetailFormValueReverseTransformer(
    model: NoteDetailFormValue,
): NoteDetails {
    return {
        noteId: model.noteId,
        noteCategoryId: model.category,
        contents: model.contents,
        createdBy: undefined,
        createdOn: model.trackingOriginal?.createdOn ?? undefined,
        updatedOn: model.trackingOriginal?.updatedOn ?? undefined,
        published: undefined,
        changed: model.changed,
        diffItemId: model.diffItemId,
        createdByFirstName: model.createdByFirstName,
        createdByLastName: model.createdByLastName,
        updatedBy: model.updatedBy,
        updatedByFirstName: model.updatedByFirstName,
        updatedByLastName: model.updatedByLastName,
    };
}

export function noteDetailFormValueFromNoteAndCommentaryTransformer(
    model: NoteAndCommentary,
): NoteDetailFormValue {
    return {
        trackingId: Math.random(),
        trackingTime: Date.now(),
        trackingOriginal: null,
        noteId: model.noteId,
        contents: model.contents,
        category: model.noteCategoryId,
        changed: null,
        diffItemId: model.diffItemId,
        createdByFirstName: model.createdByFirstName,
        createdByLastName: model.createdByLastName,
        updatedBy: model.updatedBy,
        updatedByFirstName: model.updatedByFirstName,
        updatedByLastName: model.updatedByLastName,
    };
}

export function manageNotes(
    notes: NoteDetails[],
    performerId: number,
    publish: boolean,
    removeEmptyWithId: boolean = false,
): NoteDetails[] {
    return (notes || [])
        .filter((e) => {
            if (e.noteId == null || removeEmptyWithId) {
                return e.contents && e.contents.trim().length !== 0;
            }
            return true;
        })
        .map((e) => ({
            ...e,
            noteId: e.noteId != null ? e.noteId : 0, // reasons
            published: publish ? true : undefined,
            publishedOn: publish ? new Date() : undefined, // yes this needs to be set
            changed: e.changed || (!e.published && publish), // TODO revise. contents check,
            createdOn: e.noteId != null ? e.createdOn : new Date(),
            updatedOn: e.changed === true ? new Date() : e.updatedOn,
        }));
}
